var exports = {
  "k": "xfd349460--bcc40e--container",
  "w": "xfd349460--bcc40e--logo",
};

module.exports = exports;
